import { IEntityCopyOptions } from "../models/content/entity-copy-options";
import { EntityCopyOptionsResource } from "../models/entity-copy-options-resource";
import { PropertyCopyOptionResource } from "../models/property-copy-option-resource";
import { RelationCopyOptionResource } from "../models/relation-copy-option-resource";

export class EntityCopyOptionsMapper {
    static map(copyOptions: IEntityCopyOptions): EntityCopyOptionsResource {
        const resource = new EntityCopyOptionsResource();
        resource.copyProfileId = copyOptions.copyProfileId;
        resource.copyProfileIdentifier = copyOptions.copyProfileIdentifier;
        resource.destinationEntityId = copyOptions.destinationEntityId;

        this.mapOptions(resource, copyOptions);

        return resource;
    }

    private static mapOptions(optionsResource: EntityCopyOptionsResource, copyOptions: IEntityCopyOptions): void {
        if (copyOptions.relationCopyOptions != null) {
            const relationOptions: Array<RelationCopyOptionResource> = [];

            copyOptions.relationCopyOptions.forEach(copyOption => {
                const relationResource = new RelationCopyOptionResource(
                    copyOption.name,
                    copyOption.method.toString(),
                    null
                );

                if (copyOption.relatedCopyOptions != null) {
                    const innerOption = new EntityCopyOptionsResource();
                    this.mapOptions(innerOption, copyOption.relatedCopyOptions);
                    relationResource.relatedCopyOptions = innerOption;
                }

                relationOptions.push(relationResource);
            });

            optionsResource.relationCopyOptions = relationOptions;
        }

        if (copyOptions.propertyCopyOptions == null) {
            return;
        }

        const propertiesOptions: Array<PropertyCopyOptionResource> = [];
        copyOptions.propertyCopyOptions.forEach(copyOption => {
            const propertyResource = new PropertyCopyOptionResource(
                copyOption.name,
                copyOption.method.toString(),
                copyOption.newValue
            );

            propertiesOptions.push(propertyResource);
        });

        optionsResource.propertyCopyOptions = propertiesOptions;
    }
}
